import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enPublic from './locales/en/public.json';
import enDashboard from './locales/en/dashboard.json';
import enAdmin from './locales/en/admin.json';
import enTeaching from './locales/en/teaching.json';
import enVerify from './locales/en/verify.json';

// Simplified Chinese
import zhCNCommon from './locales/zh-CN/common.json';
import zhCNAuth from './locales/zh-CN/auth.json';
import zhCNPublic from './locales/zh-CN/public.json';
import zhCNDashboard from './locales/zh-CN/dashboard.json';
import zhCNAdmin from './locales/zh-CN/admin.json';
import zhCNTeaching from './locales/zh-CN/teaching.json';
import zhCNVerify from './locales/zh-CN/verify.json';

// Traditional Chinese
import zhHKCommon from './locales/zh-HK/common.json';
import zhHKAuth from './locales/zh-HK/auth.json';
import zhHKPublic from './locales/zh-HK/public.json';
import zhHKDashboard from './locales/zh-HK/dashboard.json';
import zhHKAdmin from './locales/zh-HK/admin.json';
import zhHKTeaching from './locales/zh-HK/teaching.json';
import zhHKVerify from './locales/zh-HK/verify.json';

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    public: enPublic,
    dashboard: enDashboard,
    admin: enAdmin,
    teaching: enTeaching,
    verify: enVerify,
  },
  'zh-CN': {
    common: zhCNCommon,
    auth: zhCNAuth,
    public: zhCNPublic,
    dashboard: zhCNDashboard,
    admin: zhCNAdmin,
    teaching: zhCNTeaching,
    verify: zhCNVerify,
  },
  'zh-HK': {
    common: zhHKCommon,
    auth: zhHKAuth,
    public: zhHKPublic,
    dashboard: zhHKDashboard,
    admin: zhHKAdmin,
    teaching: zhHKTeaching,
    verify: zhHKVerify,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ['en', 'zh-CN', 'zh-HK'],
    fallbackLng: 'en',
    load: 'currentOnly',
    defaultNS: 'common',
    ns: ['common', 'auth', 'public', 'dashboard', 'admin', 'teaching', 'verify'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18n_lang',
      caches: ['localStorage'],
      convertDetectedLanguage: (lng: string) => {
        // Map zh-TW and zh-Hant variants to zh-HK
        if (lng === 'zh-TW' || lng === 'zh-Hant' || lng.startsWith('zh-Hant')) {
          return 'zh-HK';
        }
        // Map any zh variant to zh-CN
        if (lng === 'zh' || lng.startsWith('zh-CN') || lng.startsWith('zh-Hans')) {
          return 'zh-CN';
        }
        // Map any en variant (en-US, en-GB, etc.) to en
        if (lng.startsWith('en')) {
          return 'en';
        }
        return lng;
      },
    },
  });

// Set document language on init and on change
const setDocLang = (lng: string) => {
  document.documentElement.lang = lng;
};
setDocLang(i18n.language);
i18n.on('languageChanged', setDocLang);

export default i18n;
